import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Text, XenIcon } from 'xen-ui';
/**
 * Style error messages in form components or other UI elements.
 */
export const ErrorText = ({ component = 'p', message, ...props }) => {
    return (_jsxs(Text, { c: "red", component: component, display: "flex", fw: "bold", size: "xs", style: { alignItems: 'center', gap: '0.25rem', ...props?.style }, ...props, children: [_jsx(XenIcon.AlertTriangle, { size: "sm", style: { flexShrink: 0 } }), " ", message] }));
};
